import { FC } from 'react';

type Props = {
	value?: string;
};
const TagCustomCell: FC<Props> = ({ value }) => {
	return <div>{value}</div>;
};

export { TagCustomCell };
